/**
 * Shared RustScript overlay shell.
 * Every modal uses this structure so padding / title / body / footer spacing match.
 *
 *   .rustscript-overlay[.rs-overlay-prompt|.rs-overlay-wide|.rs-overlay-modal|.rs-overlay-workspace|.rs-overlay-status]
 *     h2.rs-overlay-title  |  .rs-overlay-head
 *     .rs-overlay-body     (optional)
 *     .rs-overlay-actions  (optional)
 */
function buildRustscriptOverlay() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$titleClass = _ref.titleClass,
    titleClass = _ref$titleClass === void 0 ? '' : _ref$titleClass,
    _ref$headHtml = _ref.headHtml,
    headHtml = _ref$headHtml === void 0 ? '' : _ref$headHtml,
    _ref$bodyHtml = _ref.bodyHtml,
    bodyHtml = _ref$bodyHtml === void 0 ? '' : _ref$bodyHtml,
    _ref$actionsHtml = _ref.actionsHtml,
    actionsHtml = _ref$actionsHtml === void 0 ? '' : _ref$actionsHtml,
    _ref$actionsClass = _ref.actionsClass,
    actionsClass = _ref$actionsClass === void 0 ? 'rs-overlay-actions-end' : _ref$actionsClass;
  var head = headHtml ? headHtml : title ? "<h2 class=\"rs-overlay-title".concat(titleClass ? " ".concat(titleClass) : '', "\">").concat(title, "</h2>") : '';
  var body = bodyHtml ? "<div class=\"rs-overlay-body\">".concat(bodyHtml, "</div>") : '';
  var actions = actionsHtml ? "<div class=\"rs-overlay-actions ".concat(actionsClass, "\">").concat(actionsHtml, "</div>") : '';
  return "\n<div class=\"rustscript-overlay ".concat(className, "\">\n  ").concat(head, "\n  ").concat(body, "\n  ").concat(actions, "\n</div>");
}

/**
 * Full-viewport host for publish / import / unlock overlays.
 *
 * SaitoOverlay.pullOverlayToFront() sets inline `display: block`, which defeats
 * flex centering on the shell. Centering is therefore owned by CSS absolute
 * positioning of `.rustscript-overlay` inside `.rs-publish-overlay-shell`
 * (see rustscript-publish.css) — do not rely on flex on the host.
 */
function applyPublishOverlayShell(overlay) {
  if (!(overlay !== null && overlay !== void 0 && overlay.ordinal)) {
    return;
  }
  var el = document.getElementById("saito-overlay".concat(overlay.ordinal));
  var backdrop = document.getElementById("saito-overlay-backdrop".concat(overlay.ordinal));
  if (el) {
    el.classList.add('rs-publish-overlay-shell', 'maximized-overlay');
    el.classList.remove('center-overlay');
    el.style.pointerEvents = 'none';
    el.style.zIndex = '100002';
    // Clear Saito's translate centering; shell uses inset:0 + child absolute center.
    el.style.left = '';
    el.style.top = '';
    el.style.transform = 'none';
  }
  if (backdrop) {
    backdrop.classList.add('rs-publish-overlay-backdrop');
    backdrop.style.display = 'block';
    backdrop.style.pointerEvents = 'auto';
    backdrop.style.top = '0';
    backdrop.style.left = '0';
    backdrop.style.width = '100vw';
    backdrop.style.height = '100dvh';
    backdrop.style.zIndex = '100001';
  }
  if (typeof overlay.pullOverlayToFront === 'function') {
    overlay.pullOverlayToFront();
  }

  // pullOverlayToFront writes display:block (and again after 50ms). Keep the
  // full-viewport host as a positioning context; child centering is CSS absolute.
  if (el) {
    el.style.display = 'block';
    el.style.transform = 'none';
  }
}
module.exports = {
  buildRustscriptOverlay: buildRustscriptOverlay,
  applyPublishOverlayShell: applyPublishOverlayShell
};